import ArticleHeader from './ArticleHeader'
import ArticleLead from './ArticleLead'
import ArticleMetadata from './ArticleMetadata'
import SharingAndCommentWrapper from './ArticleMetadata/SharingAndCommentWrapper'
import CommentButton from './CommentButton'
import HeadlineHeroImage from './HeadlineHeroImage'
import TitleCatchword from './TitleCatchword'

const exports = {
  ArticleHeader,
  ArticleLead,
  ArticleMetadata,
  CommentButton,
  SharingAndCommentWrapper,
  TitleCatchword,
  HeadlineHeroImage,
}

export default exports
